import React, { useEffect, useState, useRef } from 'react';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { addDevice, getOttSettings, getRegions, getSubscriber, saveSubscriberLoginHistory, sendOTP, signUpSubscriber } from '../../Api/api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { utility } from '../../utility/utility';
import { ANALYTICS_EVENTS, DISPLAYPLATFORM, LOCAL_STORAGE_KEY, PLATFORM } from '../../constant';
import AnalyticsManager from '../../analytics/analyticsManager';

const SignupWeb = () => {
    const { ref, focusKey } = useFocusable();
    const navigate = useNavigate();

    const initialState = {
        name: '',
        email: '',
        mobileNumber: '',
        region: ''
    };

    const [dataItem, setDataItem] = useState(initialState);
    const [otpCode, setOtpCode] = useState(['', '', '', '']);
    const [showVerifyOTP, setShowVerifyOTP] = useState({ show: false, OTP: '' });
    const [ottSetting, setOttSetting] = useState({});
    const [regions, setRegions] = useState([]);
    const [sentOTPResMessage, setSentOTPResMessage] = useState('');

    const inputRefs = useRef([]);

    useEffect(() => {
        loadCombo();
        (async () => {
            const response = await getOttSettings();
            if (response.success) {
                setOttSetting({
                    ...response.data,
                    piPageSetting: response?.piPageSetting || null
                });
            }
        })();
    }, []);

    const loadCombo = async () => {
        const ottSettingRes = await getOttSettings();
        if (ottSettingRes.success) {
            setOttSetting({
                ...ottSettingRes.data,
                piPageSetting: ottSettingRes?.piPageSetting || null
            });
        }
        const regionRes = await getRegions();
        if (regionRes.success) {
            setRegions(regionRes.data);
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name, value);
        setDataItem(prev => ({ ...prev, [name]: value }));
    };

    const handleGetOTP = async () => {
        const { name, email, mobileNumber, region } = dataItem;
        if(!name || name === '') {
            toast.error('Please Enter Name');
            return;
        }else if(!email || email === '' || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
            toast.error('Please Enter Valid Email');
            return;
        }else if(!region || Object.keys(region).length === 0) {
            toast.error('Please Select Region');
            return;
        }else if(!mobileNumber || mobileNumber === '') {
            toast.error('Please Enter Valid Mobile Number');
            return;
        }
        let subscriber = await getSubscriber(mobileNumber);
        if (subscriber.success) {
            toast.error("Subscriber already exist !!");
            return
        }

        let otpRes = await sendOTP({
            name: name,
            Email: email,
            RMN: mobileNumber,
            region: region
        });
        console.log(otpRes);
        if (otpRes.success) {
            setSentOTPResMessage(otpRes.message);
            setShowVerifyOTP({ show: true, OTP: otpRes.data.otp });
        } else {
            toast.error(otpRes.message);
        }
    };

    const handleOTPChange = (value, index) => {
        if (!/^\d?$/.test(value)) return; // allow only digits or empty

        const newOtp = [...otpCode];
        newOtp[index] = value;
        setOtpCode(newOtp);

        // Move to next input
        if (value && index < 3) {
            inputRefs.current[index + 1]?.focus();
        }

        // Auto verify if last digit is entered
        if (index === 4 && value && newOtp.join('') === '1234') {
            handleVerifyOTP();
        }
    };

    const handleVerifyOTP = async () => {
        const enteredOTP = otpCode.join('');
        if (enteredOTP?.toString() === showVerifyOTP?.OTP?.toString()) {
            console.log('OTP verified:', enteredOTP, "to", showVerifyOTP.OTP);

            const selectedRegion = regions.find(r => r.Description === dataItem.region);

            let res = await signUpSubscriber({...dataItem, region: {_id:selectedRegion?._id, Description: selectedRegion?.Description}, saveUserInDb: true});
            console.log(res);
            if(res.success) {
                // Analytics event
                AnalyticsManager().logEvent(ANALYTICS_EVENTS.SIGNUP, res.data?.user);
                await addDevice(res.data?.user?._id, (res.data?.user?.Name + '`s Device'));
                await saveSubscriberLoginHistory(res.data?.user?._id, PLATFORM[DISPLAYPLATFORM.WEB].Description);
                utility.setValue(LOCAL_STORAGE_KEY.user, res.data?.user);
                navigate('/dashboard');
            }else{
                toast.error(res.message);
            }
        } else {
            toast.error('Invalid OTP.');
            setOtpCode(['', '', '', '']);
            inputRefs.current[0]?.focus();
        }
    };

    const renderInput = (type, name, placeholder) => (
        <div style={{ marginBottom: '20px' }}>
            <input
                type={type}
                name={name}
                placeholder={placeholder}
                value={dataItem[name]}
                onChange={handleChange}
                style={{
                    width: '100%',
                    padding: '12px',
                    fontSize: '14px',
                    backgroundColor: "#15181F",
                    color: '#fff',
                    border: '1px solid #707A94',
                    borderRadius: '10px'
                }}
            />
        </div>
    );

    const styles = {
        primaryButton: {
            width: '100%',
            padding: '15px',
            fontSize: '16px',
            fontWeight: 'bold',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.2s'
        },
        linkButton: {
            background: 'none',
            border: 'none',
            color: '#0156B3',
            fontSize: '16px',
            cursor: 'pointer',
            fontWeight: 'bold',
            textDecoration: 'underline'
        },
        otpContainer: {
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            margin: '30px 0'
        },
        otpBox: {
            width: '60px',
            height: '60px',
            fontSize: '24px',
            fontWeight: 'bold',
            textAlign: 'center',
            border: '2px solid #ccc',
            borderRadius: '8px',
            backgroundColor: '#fff',
            outline: 'none'
        }
    };

    return (
        <FocusContext.Provider value={focusKey}>
            <div
                ref={ref}
                style={{
                    minHeight: '100vh',
                    background: 'linear-gradient(180deg, #010001 0%, #000000 100%)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px',
                    fontFamily: 'Arial, sans-serif'
                }}
            >
                <div
                    style={{
                        backgroundColor: '#15181F',
                        borderRadius: '20px',
                        padding: '40px',
                        maxWidth: '500px',
                        width: '100%',
                        boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
                    }}
                >
                    <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                        <img
                            src={ottSetting?.logo ?? 'path/to/default-logo.png'}
                            alt="Logo"
                            onClick={() => navigate('/')}
                            style={{ height: '100px', cursor: 'pointer' }}
                            className="max-w-full"
                        />
                    </div>

                    {!showVerifyOTP.show ? (
                        <>
                            {renderInput('text', 'name', 'Name')}
                            {renderInput('email', 'email', 'Email')}

                            <div style={{ marginBottom: '20px' }}>
                                <select
                                    name="region"
                                    value={dataItem.region}
                                    onChange={handleChange}
                                    style={{
                                        width: '100%',
                                        padding: '15px',
                                        fontSize: '14px',
                                        backgroundColor: "#15181F",
                                        color: '#fff',
                                        border: '1px solid #707A94',
                                        borderRadius: '8px',
                                        outline: 'none',
                                        boxSizing: 'border-box'
                                    }}
                                >
                                    <option value="">Select Region</option>
                                    {regions.map(region => (
                                        <option key={region?._id} value={region?.Description}>{region?.Description}</option>
                                    ))}
                                </select>
                            </div>

                            {renderInput('tel', 'mobileNumber', 'Mobile Number')}

                            <button
                                onClick={handleGetOTP}
                                style={styles.primaryButton}
                            >
                                Get OTP
                            </button>

                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <span style={{ color: '#ccc' }}>Already have an account? </span>
                                <button
                                    style={styles.linkButton}
                                    onClick={() => navigate('/loginWeb')}
                                >
                                    Login
                                </button>
                            </div>
                        </>
                    ) : (
                        <div style={{ textAlign: 'center' }}>
                            <h3 style={{ color: '#fff' }}>Enter OTP</h3>
                            <p style={{ color: '#ccc' }}>{sentOTPResMessage}</p>

                            <div style={styles.otpContainer}>
                                {[0, 1, 2, 3].map((_, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        maxLength="1"
                                        value={otpCode[index]}
                                        ref={el => inputRefs.current[index] = el}
                                        onChange={e => handleOTPChange(e.target.value, index)}
                                        style={styles.otpBox}
                                    />
                                ))}
                            </div>

                            <div>
                                <button
                                    onClick={handleVerifyOTP}
                                    style={styles.primaryButton}
                                    onMouseEnter={e => e.target.style.backgroundColor = '#00b89a'}
                                    onMouseLeave={e => e.target.style.backgroundColor = '#00d4aa'}
                                >
                                    Verify OTP
                                </button>
                            </div>

                            <button
                                onClick={() => {
                                    setShowVerifyOTP(false);
                                    setOtpCode(['', '', '', '']);
                                }}
                                style={{ ...styles.linkButton, marginTop: '20px' }}
                            >
                                Back to Sign Up
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </FocusContext.Provider>
    );
};

export default SignupWeb;
